export interface MapPoint {
    id: string;
    lat: number;
    lng: number;
    type: LocationType;
    ticketId?: string;
    benId?: string;
    fullName?: string;
    companyName: string;
    address: string;
    hospitalName?: string;
    label?: string;
}

export interface ClusterPoint {
    id: string;
    lat: number;
    lng: number;
    count: number;
    points: MapPoint[];
    type: LocationType;
}

export enum LocationType {
    PICKUP = 'PICKUP',
    DROP = 'DROP',
    HOME = 'HOME',
    WORK = 'WORK',
    OTHER = 'OTHER',
    MIXED = 'MIXED',
    TICKET = 'TICKET',
    DOCTOR_CONSULT = 'DOCTOR_CONSULT',
}

export enum LocationLabel {
    PICKUP = 'Pickup Location',
    DROP = 'Drop Location',
    HOME = 'Home Address',
    WORK = 'Work Address',
    OTHER = 'Other Address',
    MIXED = 'Mixed',
    TICKET = 'Ticket Raised Location',
    DOCTOR_CONSULT = 'Doctor Consult Location'
}

export enum LocationColor {
    PICKUP = 'red',
    DROP = 'green',
    HOME = 'red',
    WORK = 'green',
    OTHER = 'blue',
    MIXED = 'purple',
    TICKET = 'red',
    DOCTOR_CONSULT = 'blue'
}